import { SEO } from '../components/SEO';
import { useContent } from '../lib/content';

export default function Privacy() {
  const { contact } = useContent();

  return (
    <>
      <SEO
        title="Privacy Policy"
        description="How Higgins Truck Sales collects, uses and protects your personal information when you make an enquiry through our website."
        path="/privacy"
      />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-wider text-[#24135F]">PRIVACY POLICY</h1>
        <p className="text-[#53565A] mt-2 text-sm">Last updated: February 2026</p>

        <div className="mt-8 space-y-8 text-sm text-[#53565A] leading-relaxed">
          <section>
            <h2 className="font-heading text-xl tracking-wider text-[#24135F] mb-2">WHO WE ARE</h2>
            <p>
              Higgins Truck Sales is part of Higgins Services. This policy explains how we handle personal information
              collected through this website.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl tracking-wider text-[#24135F] mb-2">WHAT WE COLLECT</h2>
            <p>
              When you submit an enquiry we collect only the information needed to respond to you: your name, email
              address, phone number (optional), your message, and the vehicle you enquired about. We do not collect
              payment information through this website.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl tracking-wider text-[#24135F] mb-2">HOW WE USE IT</h2>
            <p>
              Your enquiry details are used solely to respond to your enquiry about our vehicles and services. Enquiry
              notifications are sent to our sales team by email. We do not sell or share your personal information with
              third parties for marketing purposes.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl tracking-wider text-[#24135F] mb-2">STORAGE AND RETENTION</h2>
            <p>
              Enquiries are stored securely and are accessible only to authorised Higgins staff. We retain enquiry
              records for up to 24 months for business follow-up purposes, after which they may be deleted. You may
              request deletion of your enquiry information at any time using the contact details below.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl tracking-wider text-[#24135F] mb-2">YOUR RIGHTS</h2>
            <p>
              You may request access to, correction of, or deletion of your personal information held by us. To make a
              request, contact us at{' '}
              <a href={`mailto:${contact.email}`} className="text-[#E4002B] hover:underline">
                {contact.email}
              </a>{' '}
              or call {contact.phone}.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl tracking-wider text-[#24135F] mb-2">CONTACT</h2>
            <p className="whitespace-pre-line">
              Higgins Truck Sales{'\n'}
              {contact.address}{'\n'}
              {contact.phone}{'\n'}
              {contact.email}
            </p>
          </section>
        </div>
      </div>
    </>
  );
}
